import { render, staticRenderFns } from "./submittedSuccessfully.vue?vue&type=template&id=849e6f56&scoped=true&"
import script from "./submittedSuccessfully.vue?vue&type=script&lang=js&"
export * from "./submittedSuccessfully.vue?vue&type=script&lang=js&"
import style0 from "./submittedSuccessfully.vue?vue&type=style&index=0&id=849e6f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849e6f56",
  null
  
)

export default component.exports